import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { IoAddOutline } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ActionButton,
  Alert,
  BackButton,
  CRUDLayout,
  DataStatus,
  FilterButton,
  InputSearch,
  Pagination,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr,
} from 'components';
import { WorkOrderApi } from 'api';
import { DateConvert, PageNumber } from 'utilities';
import { ModalFilterPreformPage } from './components';
import { workOrderProvider } from './context';

export const ListMaintenanceRequestWorkOrder = workOrderProvider(
  ({ setNavbarTitle }) => {
    const history = useHistory();
    const location = useLocation();
    const title = 'Work Order';
    const filter = location.state?.filter ?? {};

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalPage, setTotalPage] = useState(1);
    const [totalData, setTotalData] = useState('');
    const [modalFilter, setModalFilter] = useState(false);
    const [dataFilter, setDataFilter] = useState({
      active: filter.preform?.active,
      page: filter.preform?.page ?? 1,
      per_page: filter.preform?.per_page ?? 10,
      q: filter.preform?.q ?? '',
      tgl_maintenance_request_start:
        filter.preform?.tgl_maintenance_request_start,
      tgl_maintenance_request_end: filter.preform?.tgl_maintenance_request_end,
      id_item_aset: filter.preform?.id_item_aset,
    });
    const [alertConfig, setAlertConfig] = useState({
      show: false,
      variant: 'primary',
      text: '',
    });
    const [collapsedIndex, setCollapsedIndex] = useState(-1);

    // request data dari server
    const getData = () => {
      setIsLoading(true);

      const filterData = { ...dataFilter };
      delete filterData.active;

      WorkOrderApi.preform(filterData)
        .then((res) => {
          setData(res.data.data);
          setTotalPage(res.data.total_page);
          setTotalData(res.data.data_count);
        })
        .catch(() => {
          setAlertConfig({
            show: true,
            variant: 'danger',
            text: 'Data gagal dimuat!',
          });
        })
        .finally(() => setIsLoading(false));
    };

    const onInputSearchChange = (e) => {
      const key = e.target.value;

      setDataFilter({
        ...dataFilter,
        page: 1,
        q: key,
      });
      setAlertConfig({
        show: key ? true : false,
        variant: 'primary',
        text: 'Hasil dari pencarian: ' + key,
      });
    };

    useEffect(() => {
      setNavbarTitle(title);

      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      setCollapsedIndex(-1);
      getData();

      // eslint-disable-next-line
    }, [dataFilter]);

    const toggleModalFilter = () => setModalFilter(!modalFilter);

    const Table = () => {
      return (
        <>
          <b>List Data Maintenance Request Yang Siap Dibuatkan Work Order</b>
          <CRUDLayout.Table>
            <THead>
              <Tr>
                <ThFixed>No</ThFixed>
                <ThFixed>Informasi Maintenance Request</ThFixed>
                <Th>Item Aset</Th>
                <Th>Catatan Maintenance Request</Th>
                <ThFixed>Aksi</ThFixed>
              </Tr>
            </THead>

            <TBody>
              {data.map((val, index) => {
                return (
                  <Tr key={index}>
                    <TdFixed textCenter>
                      {PageNumber(dataFilter.page, dataFilter.per_page, index)}
                    </TdFixed>

                    <Td>
                      <div>
                        {val.tgl_maintenance_request_master
                          ? DateConvert(
                              new Date(val.tgl_maintenance_request_master),
                            ).defaultDMY
                          : '-'}
                      </div>
                      <div>{val.no_maintenance_request_master ?? '-'}</div>
                    </Td>

                    <Td>
                      {val.list_item_aset?.length === 0 ? (
                        '-'
                      ) : (
                        <>
                          <ul className="pl-3 m-0">
                            {val?.list_item_aset
                              ?.filter((_val, indexPermintaan) => {
                                if (index === collapsedIndex) {
                                  return (
                                    indexPermintaan <= val.list_item_aset.length
                                  );
                                } else {
                                  return indexPermintaan <= 2;
                                }
                              })
                              .map((val, index) => (
                                <li key={index}>{val.nama_item_aset ?? '-'}</li>
                              ))}
                          </ul>
                          {val?.list_item_aset?.length > 3 &&
                            index !== collapsedIndex && (
                              <Button
                                variant="link"
                                className="pt-0"
                                onClick={() => setCollapsedIndex(index)}
                              >
                                Selengkapnya...
                              </Button>
                            )}
                        </>
                      )}
                    </Td>
                    <Td>{val.catatan ?? '-'}</Td>
                    <Td>
                      <ActionButton
                        size="sm"
                        text={<IoAddOutline />}
                        onClick={() => {
                          history.push(
                            `/transaksi/work-order/tambah/${val.id_maintenance_request_master}`,
                            {
                              filter: {
                                ...filter,
                                preform: dataFilter,
                              },
                            },
                          );
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </TBody>
          </CRUDLayout.Table>

          <Pagination
            dataLength={dataFilter.per_page}
            dataPage={
              totalData <= 10
                ? data.length
                : data.map((_res, index) => {
                    if (index === data.length - 1) {
                      return PageNumber(
                        dataFilter.page,
                        dataFilter.per_page,
                        index,
                      );
                    } else {
                      return null;
                    }
                  })
            }
            dataNumber={data.map((_res, index) => {
              if (index === 0) {
                return PageNumber(dataFilter.page, dataFilter.per_page, index);
              } else {
                return null;
              }
            })}
            dataCount={totalData}
            onDataLengthChange={(e) => {
              setDataFilter({
                ...dataFilter,
                per_page: e.target.value,
                page: 1,
              });
            }}
            currentPage={dataFilter.page}
            totalPage={totalPage}
            onPaginationChange={({ selected }) =>
              setDataFilter({
                ...dataFilter,
                page: selected + 1,
              })
            }
          />
        </>
      );
    };

    return (
      <CRUDLayout>
        <CRUDLayout.Head>
          <CRUDLayout.HeadSearchSection>
            <div className="d-flex mb-3">
              <InputSearch
                value={dataFilter?.q}
                onChange={onInputSearchChange}
              />

              <FilterButton
                active={dataFilter?.active}
                onClick={toggleModalFilter}
              />
            </div>
          </CRUDLayout.HeadSearchSection>

          <CRUDLayout.HeadButtonSection>
            <BackButton
              onClick={() => {
                history.replace('/transaksi/work-order', {
                  filter: {
                    ...filter,
                    post: dataFilter,
                  },
                });
              }}
            />
          </CRUDLayout.HeadButtonSection>
        </CRUDLayout.Head>

        <Alert
          show={alertConfig.show}
          variant={alertConfig.variant}
          text={alertConfig.text}
          showCloseButton={true}
          onClose={() => {
            setAlertConfig({
              ...alertConfig,
              show: false,
            });
          }}
        />

        {isLoading ? (
          <DataStatus loading={true} text="Memuat data..." />
        ) : data.length ? (
          <Table />
        ) : (
          <DataStatus text="Tidak ada data" />
        )}

        {modalFilter && (
          <ModalFilterPreformPage
            toggle={toggleModalFilter}
            data={dataFilter}
            setData={setDataFilter}
          />
        )}
      </CRUDLayout>
    );
  },
);
